class VariantSelector extends HTMLElement {
  constructor() {
      super();
      this.cached = {};
      this.container = this.closest(".mm-section-product");
      this.addEventListener("change", this.onVariantChange);
  }

  /**
   * Handle variant change event.
   */
  onVariantChange() {
      this.getSelectedOptions();
      this.getSelectedVariant();

      if (this.currentVariant) {
          this.updateURL();
          this.variantFetch();
      }
  }

  /**
   * Get selected options from the variant checkboxes.
   */
  getSelectedOptions() {
      this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
  }

  /**
   * Get variant data from the embedded JSON.
   * 
   * @returns {Object} - The variant data.
   */
  getVariantJSON() {
      this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
  }

  /**
   * Get the selected variant based on selected options.
   */
  getSelectedVariant() {
      this.currentVariant = this.getVariantJSON().find((variant) => {
          const findings = !variant.options
              .map((option, index) => {
                  return this.options[index] === option;
              })
              .includes(false);

          if (findings) return variant;
      });
  }

  /**
   * Update the URL to include the selected variant ID.
   */
  updateURL() {
      window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  /**
   * Fetch variant data from the server and cache it.
   */
  variantFetch() {
      var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

      if (this.cached[variantUrl]) {
          this.renderVariantInfo(this.cached[variantUrl]);
          return;
      }

      fetch(variantUrl)
          .then((response) => response.text())
          .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, "text/html");
              this.cached[variantUrl] = html;
              this.renderVariantInfo(html);
          })
          .catch((e) => {
              console.error(e);
          });
  }

  /**
   * Render variant information in the DOM.
   * 
   * @param {Document} html - The HTML document containing the variant information.
   */
  renderVariantInfo(html) {
      this.updateElementOuter(".mm-product-cta", html);
  }

  /**
   * Update the inner HTML of an element.
   * 
   * @param {string} selector - The CSS selector of the element to update.
   * @param {HTMLElement} html - The HTML element containing the new content.
   */
  updateElement(selector, html) {
      const destination = this.container.querySelector(selector);
      const source = html.querySelector(selector);
      if (source && destination) destination.innerHTML = source.innerHTML;
  }

  /**
   * Update the outer HTML of an element.
   * 
   * @param {string} selector - The CSS selector of the element to update.
   * @param {HTMLElement} html - The HTML element containing the new content.
   */
  updateElementOuter(selector, html) {
      const destination = this.container.querySelector(selector);
      const source = html.querySelector(selector);
      if (source && destination) destination.outerHTML = source.outerHTML;
  }
}

// Define the custom element
customElements.define("variant-selector", VariantSelector);












